import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: returning from Google OAuth — AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) return;
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("td_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("td_token", data.access_token);
    setUser(data.user);
  };

  const googleLogin = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    setUser(data);
    return data;
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("td_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, googleLogin, logout }}>{children}</AuthContext.Provider>;
}
